import { ComponentView, ObservableArray } from "binder";
import { getAsBoolean } from "../../../utilities";
import { ColumnSearcher, SearchValue, StringFilterViewModel } from "./stringFilter-viewModel"

export class StringFilterView extends ComponentView<StringFilterViewModel>{
    GetViewUniqueId(): string {
        return "V-5F40E94D-A474-4B2E-9C0F-56E330971227"
    }
    loadHtml(): string {
        let element = require('./stringFilter.html').default;
        let style = require('./stringFilter.less');
        return element;
    }
    constructor() {
       super();
    }

    public set shallUseTables(v: boolean) { this._shallUseTables = v; } public get shallUseTables(): boolean { return this._shallUseTables;} private _shallUseTables: boolean;
    public set containsValue(v: string) { this._containsValue = v; } public get containsValue(): string { return this._containsValue;} private _containsValue: string;
    public set isActive(v: boolean) { this._isActive = getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set searchValues(v: ObservableArray<SearchValue>) { this._searchValues = v; } public get searchValues(): ObservableArray<SearchValue> { return this._searchValues;} private _searchValues: ObservableArray<SearchValue>;
    public set comboViewModel(v: ColumnSearcher) { this._comboViewModel = v; } public get comboViewModel(): ColumnSearcher { return this._comboViewModel;} private _comboViewModel: ColumnSearcher;
    public set isExclude(v: boolean) { this._isExclude = v; } public get isExclude(): boolean { return this._isExclude;} private _isExclude: boolean;
    
    apply(){
        this.isActive = true;
        this.dataContext.apply();
    }

    
    removeFilter(){
        this.isActive = false;
        this.dataContext.apply();
    }
}
